import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommunityIntegrationCard = ({ isConnected, memberCount, lastActivity }) => {
  const navigate = useNavigate();

  const handleConnect = () => {
    window.open('https://www.skool.com', '_blank');
  };

  const handleViewCommunity = () => {
    window.open('https://www.skool.com', '_blank');
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-sm overflow-hidden">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-secondary/10 rounded-lg flex items-center justify-center">
              <Icon name="Users" size={24} color="var(--color-secondary)" />
            </div>
            <div>
              <h3 className="text-base font-heading font-semibold text-foreground">
                Skool Community
              </h3>
              <p className="text-xs text-muted-foreground">
                {isConnected ? 'Connected' : 'Not Connected'}
              </p>
            </div>
          </div>
          <div className={`w-3 h-3 rounded-full ${isConnected ? 'bg-success' : 'bg-muted'}`} />
        </div>

        {isConnected ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-muted/30 rounded-lg p-3">
                <p className="text-xs text-muted-foreground mb-1">Members</p>
                <p className="text-lg font-heading font-bold text-foreground">
                  {memberCount?.toLocaleString()}
                </p>
              </div>
              <div className="bg-muted/30 rounded-lg p-3">
                <p className="text-xs text-muted-foreground mb-1">Last Active</p>
                <p className="text-lg font-heading font-bold text-foreground">
                  {lastActivity}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-2 p-3 bg-primary/5 rounded-lg border border-primary/20">
              <Icon name="Info" size={16} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs text-foreground">
                Connect with fellow authors, share insights, and get feedback on your book projects.
              </p>
            </div>

            <Button
              variant="outline"
              size="sm"
              fullWidth
              iconName="ExternalLink"
              iconPosition="right"
              onClick={handleViewCommunity}
            >
              Open Community
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Join our exclusive Skool community to connect with other authors, share experiences, and accelerate your book creation journey.
            </p>

            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-foreground">
                <Icon name="Check" size={16} color="var(--color-success)" />
                <span>Expert guidance and support</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-foreground">
                <Icon name="Check" size={16} color="var(--color-success)" />
                <span>Networking opportunities</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-foreground">
                <Icon name="Check" size={16} color="var(--color-success)" />
                <span>Exclusive resources and templates</span>
              </div>
            </div>

            <Button
              variant="default"
              size="sm"
              fullWidth
              iconName="Users"
              iconPosition="left"
              onClick={handleConnect}
            >
              Connect to Skool
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityIntegrationCard;